export default "__VITE_ASSET__f2006a1b__"